import { useMemo } from "react";
import { useAuth } from "../../../../context_providers/auth/authProvider";
import { ACTION, MODULE } from "../../../../utils/enums";

const HIGH_PRIORITY_WAREHOUSE_ROLE_TITLES = [
  "Warehouse Module Admin",
  "Warehouse Manager",
  "Warehouse Module Operator",
  "Warehouse Module Finance",
  "Warehouse Module Stock Transfer Creator",
];

export function useWarehouseViewOnly(): boolean {
  const { isAuthorised, hasRoleTitle } = useAuth();

  return useMemo(() => {
    const hasViewOnlyPermission = isAuthorised({
      module: MODULE.warehouse_module_view_only,
      action: ACTION.READ,
    });

    if (!hasViewOnlyPermission) return false;

    const hasHigherPriorityRole = HIGH_PRIORITY_WAREHOUSE_ROLE_TITLES.some(
      (roleTitle) => hasRoleTitle({ roleTitle }),
    );

    return hasViewOnlyPermission && !hasHigherPriorityRole;
  }, [hasRoleTitle, isAuthorised]);
}
